<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{
          $getVisibleNames(
            "mesh.basematterwrapper",
            false,
            "Envoltorio de Asignaturas"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.basematterwrapper'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_basematterwrapper'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.basematterwrapper',
                  false,
                  'Envoltorio de Asignaturas'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-base-matter-wrapper-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="baseMattersWrapperList"
        :pagination="base_matters_wrapper.length"
        :fields="base_matters_wrapper_fields"
        :filter="input_search"
        :filterCustom="filterCustom"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @emitChangeSearchField="changeInputSearch"
      >
        <template #cell(color)="row">
          <div
            class="base-matter-wrapper-color"
            :style="{
              'background-color': row.item.color,
              color: row.item.color,
            }"
          ></div>
        </template>
        <template #cell(matters)="row">
          <div class="campus-container">
            <div
              v-for="item in getMatterName(row.item.matters)"
              :key="item.id"
              class="campus-div"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex">
            <template v-if="allows_crud">
              <ButtonSmall
                v-can="'mesh.change_basematterwrapper'"
                :tooltip_text="
                  $t('reusable.common.editTooltip', {
                    entity: $getVisibleNames(
                      'mesh.basematterwrapper',
                      false,
                      'Envoltorio de Asignaturas'
                    ),
                  })
                "
                :click_button="
                  () =>
                    $bvModal.show(
                      `edit-base-matter-wrapper-modal-${row.item.id}`
                    )
                "
                :class="``"
                :icon="'square'"
              ></ButtonSmall>
              <ButtonSmall
                v-can="'mesh.delete_basematterwrapper'"
                :click_button="() => askForDeleteBaseMatterWrapper(row.item.id)"
                :tooltip_text="
                  $t('reusable.common.deleteTooltip', {
                    entity: $getVisibleNames(
                      'mesh.basematterwrapper',
                      false,
                      'Envoltorio de Asignaturas'
                    ),
                  })
                "
                :icon="'trash'"
              ></ButtonSmall>
            </template>
          </div>
          <b-modal
            :id="`edit-base-matter-wrapper-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.basematterwrapper',
                  false,
                  'Envoltorio de Asignaturas'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <BaseMattersWrapperForm
              :BaseMatterWrapper="row.item"
              @updated="slotUpdatedBaseMatterWrapper"
            ></BaseMattersWrapperForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-base-matter-wrapper-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.basematterwrapper',
            false,
            'Envoltorio de Asignaturas'
          ),
        })
      "
      size="lg"
    >
      <BaseMattersWrapperForm
        @created="slotCreatedBaseMatterWrapper"
      ></BaseMattersWrapperForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "BaseMattersWrapperView",
  components: {
    BaseMattersWrapperForm: () =>
      import(
        "@/components/mesh/Matrix2/BaseMattersWrapper/BaseMattersWrapperForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    // allows_crud: {
    //   type: Boolean,
    //   required: true,
    // },
  },
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      formationAreas: names.FORMATION_AREAS,
      base_matters_wrapper: names.BASE_MATTERS_WRAPPER,
      matters: names.MATTERS,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.basematterwrapper",
            false,
            "Envoltorio de Asignaturas"
          ),
        },
      ];
    },
    baseMattersWrapperList() {
      return this.base_matters_wrapper;
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "mesh.change_basematterwrapper"
      );
      if (
        has_permission &&
        this.user &&
        (this.user.group_names.includes(
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
        ) ||
          this.user.is_superuser)
      )
        return has_permission;
      else return false;
    },
    base_matters_wrapper_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.basematterwrapper",
              true,
              "Envoltorios de Asignaturas"
            )
          ),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: String(this.$t("reusable.common.description")),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "init_level",
          label: String(
            this.$t("curricularDefinitions.baseMatterWrapper.initialLevel")
          ),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "end_level",
          label: String(
            this.$t("curricularDefinitions.baseMatterWrapper.finalLevel")
          ),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "formation_area",
          label: this.$getVisibleNames(
            "mesh.formationarea",
            false,
            "Área De Formación"
          ),
          sortable: false,
          display_column: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          formatter: (value) => {
            return this.getFormationArea(value);
          },
        },
        {
          key: "credits",

          label: this.$getVisibleNames(
            "manual.credits",
            true,
            "Créditos SCT Totales"
          ),
          sortable: true,
          thClass: "text-center align-middle",
          tdClass: "text-center",
          display_column: true,
        },
        // {
        //   key: "color",
        //   label: "Color",
        //   sortable: false,
        //   display_column: true,
        // },
        {
          key: "matters",
          label: String(
            this.$getVisibleNames("teaching.matter", true, "Asignaturas")
          ),
          thClass: "text-center align-middle",
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(String(row.name), this.input_search) ||
        this.$filtered(String(row.description), this.input_search) ||
        this.$filtered(String(row.init_level), this.input_search) ||
        this.$filtered(String(row.end_level), this.input_search) ||
        this.$filtered(String(row.credits), this.input_search) ||
        this.$filtered(
          String(this.getFormationArea(row.formation_area)),
          this.input_search
        ) ||
        this.matters.filter(
          (x) =>
            row.matters.includes(x.id) &&
            this.$filtered(x.name, this.input_search)
        ).length > 0
      ) {
        return true;
      } else {
        false;
      }
    },
    getMatterName(matters_ids) {
      const matters = [...new Set(matters_ids)];
      if (matters.length > 0) {
        const list = this.matters.filter((element) =>
          matters.includes(element.id)
        );
        return list.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
      } else return [];
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    askForDeleteBaseMatterWrapper(base_matter_wrapper_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.basematterwrapper",
            false,
            "Envoltorio de Asignaturas"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_BASE_MATTER_WRAPPER, base_matter_wrapper_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.basematterwrapper",
                    false,
                    "Envoltorio de Asignaturas"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedBaseMatterWrapper() {
      this.$bvModal.hide("new-base-matter-wrapper-modal");
    },
    slotUpdatedBaseMatterWrapper(base_matter_wrapper) {
      this.$bvModal.hide(
        `edit-base-matter-wrapper-modal-${base_matter_wrapper.id}`
      );
    },
    getFormationArea(formation_area_id) {
      if (!this.formationAreas) return "N/A";
      const formation_area = this.formationAreas.find(
        (x) => x.id == formation_area_id
      );
      return formation_area ? formation_area.name : "N/A";
    },
  },
  mounted() {},
  created() {
    if (this.formationAreas.length == 0) {
      this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    }
    this.$store.dispatch(names.FETCH_MODALITIES);
    this.$store.dispatch(names.FETCH_MATTER_CONTRIBUTIONS);
    this.$store.dispatch(names.FETCH_MATTER_TYPES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_BASE_MATTERS_WRAPPER);
    this.$store.dispatch(names.FETCH_MATTERS, { is_elective: true });
  },
};
</script>

<style scoped>
.campus-div {
  background-color: var(--primary-color);
  color: white;
  max-width: fit-content;
  border-radius: 3px;
  margin: 0.1em 0.1em;
  padding: 1px 4px;
  flex-grow: 1;
  font-size: var(--thirth-font-size);
  text-align: center;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}
.base-matter-wrapper-color::before {
  min-width: 100px !important;
  height: 20px !important;
  opacity: 1;
  content: " #";
}
</style>